import { gql, useMutation } from '@apollo/client';
import { subscriptionsPublicClient } from 'lib/apollo/clients';

export const QUERY = gql`
  mutation ResendVerificationToken($input: ResendVerificationTokenInput!) {
    ResendVerificationToken(input: $input)
  }
`;

const useResendVerificationCode = () => {
  const [mutate, { loading }] = useMutation(QUERY, {
    client: subscriptionsPublicClient,
  });

  const resend = (firstName, lastName, email, phone) => {
    let variables = { input: { email, phone, firstName, lastName } };
    return mutate({ variables });
  };

  return { resend, loading };
};

export default useResendVerificationCode;
